import React from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import ReactHtmlParser from 'react-html-parser'

export default class EmailSignup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: false,
      label: {
        class: '',
        text: ''
      }
    }
  }

  handleChange = e => {
    this.setState({ [ e.target.name ]: e.target.value })
  };

  handleSubmit = async e => {
    e.preventDefault()
    try {
      const { email } = this.state
      this.setState({ isLoading: true })
      const { msg } = await addToMailchimp(email)
      this.setState({
        label: { text: msg, class: 'is-success' },
        isLoading: false
      })
      setTimeout(() => {
        this.setState({ label: { text: '', class: '' } })
      }, 5000)
    } catch (error) {
      this.setState({
        label: { text: error.message, class: 'is-danger' },
        isLoading: false
      })
    }
  };

  render () {
    return (
      <form
        id="signup-form"
        className="footer-signup"
        onSubmit={this.handleSubmit}
      >
        <noscript>
          <p>This form won’t work with Javascript disabled</p>
        </noscript>
        <div className="field has-addons">
          <div className="control">
            <label htmlFor="email">
              <span hidden>Email Address</span>
              <input
                className="input is-black has-text-white"
                type="email"
                name="email"
                id="email"
                placeholder="Subscribe"
                aria-label="Email Address for subcription"
                onChange={this.handleChange}
                required
              />
            </label>
          </div>
          <div className="control">
            <button
              className={`button is-black ${
                this.state.isLoading ? 'is-loading' : ''
              }`}
              aria-label="Send"
            >
              Send
            </button>
          </div>
        </div>
        <span className={`help ${this.state.label.class}`}>
          {ReactHtmlParser(this.state.label.text)}
        </span>
      </form>
    )
  }
}
